import { useQuery } from "react-query";
import { getPrizes } from "services/prize";

export default function usePrizes() {
  return useQuery("prizes", async () => await getPrizes());
}
